<script>
import Swal from "sweetalert2";
import PrincipalHeader from "@/views/pages/dashboard/principal/components/Principal-header.vue";
import PrincipalSidebar from "@/views/pages/dashboard/principal/components/Principal-sidebar.vue";
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";
import { useSharedStore } from "@/stores/shared-store";
import { onMounted, computed, ref } from "vue";
import { useCourseFetchStore } from "@/stores/course/course-fetch-store.js";
import { useCourseDataStore } from "@/stores/course/course-data-store.js";
import { useEnrollmentStore } from "@/stores/access/enrollment-store.js";
import { useAuthStore } from "@/stores/auth-store";
import CourseFilter from "@/components/CustomComponent/modal/course-filter.vue";
import { useUserStore } from "@/stores/user/user-store";

export default {
  components: {
    PrincipalHeader,
    PrincipalSidebar,
    BaseLoading,
    CourseFilter,
  },
  data() {
    return {
      headers: [
        { text: "Course", value: "course" },
        { text: "Student", value: "student" },
        { text: "Status", value: "status" },
      ],
    };
  },
  setup() {
    const sharedStore = useSharedStore();
    const authStore = useAuthStore();
    const courseFetchStore = useCourseFetchStore();
    const courseDataStore = useCourseDataStore();
    const enrollmentStore = useEnrollmentStore();
    const userStore = useUserStore();
    const currentPage = ref(1);
    const itemsPerPage = ref(5);

    const activeCourseCount = computed(
      () =>
        courseFetchStore.courseList.filter(
          (course) =>
            course.status === "Active" || course.status === "Need Approval Edit"
        ).length
    );
    const disabledCourseCount = computed(
      () =>
        courseFetchStore.courseList.filter(
          (course) => course.status === "Disabled"
        ).length
    );
    const totalPages = computed(() => {
      const total = courseFetchStore.filteredAllCourses?.length || 0;
      const perPage = itemsPerPage.value || 1;
      return Math.max(1, Math.ceil(total / perPage));
    });
    const paginatedCourses = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;
      return courseFetchStore.filteredAllCourses.slice(start, end);
    });

    const selectedCourse = ref(null);
    const isApproving = ref(false);

    onMounted(() => {
      courseFetchStore.fetchCourseList();
      enrollmentStore.fetchEnrollmentList();
      userStore.fetchTeachers();
    });
    return {
      sharedStore,
      authStore,
      courseFetchStore,
      courseDataStore,
      enrollmentStore,
      userStore,
      activeCourseCount,
      disabledCourseCount,
      totalPages,
      paginatedCourses,
      currentPage,
      itemsPerPage,
      selectedCourse,
      isApproving,
    };
  },
  methods: {
    async deleteCourse(course) {
      if (this.sharedStore.loading) return;

      const result = await Swal.fire({
        title: "Hapus Course?",
        text: "Aksi ini tidak dapat dibatalkan.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, Hapus",
        cancelButtonText: "Batal",
      });
      if (!result.isConfirmed) return;

      await this.courseDataStore.deleteCourse(course);
    },
    editCourse(courseID) {
      this.$router.push({ name: "CourseEdit", params: { courseID } });
    },
    isPendingApproval(status) {
      if (!status) return false;
      const s = String(status).toLowerCase().trim();
      return (
        s === "new" ||
        s === "need approval edit" ||
        (s.includes("approval") && s.includes("edit")) ||
        s.includes("need edit")
      );
    },
    selectCourseForApproval(course) {
      this.selectedCourse = course;
    },
    async handleApproveCourse() {
      if (!this.selectedCourse) return;
      const course = this.selectedCourse;

      const result = await Swal.fire({
        title: "Konfirmasi Approval",
        text: `Apakah Anda yakin ingin menyetujui (approve) course "${course.title}"?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, Approve!",
        cancelButtonText: "Batal",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
      });

      if (result.isConfirmed) {
        try {
          this.isApproving = true;
          await this.courseDataStore.approveCourse(course.course_id);
          await this.courseFetchStore.fetchCourseList();
          document.getElementById("closeApproveModalBtn")?.click();
          Swal.fire({
            icon: "success",
            title: "Berhasil Disetujui!",
            text: `Course "${course.title}" telah berhasil di-approve.`,
            timer: 2000,
            showConfirmButton: false,
          });
        } catch (error) {
          console.error("Gagal approve course:", error);
          Swal.fire("Gagal!", "Terjadi kesalahan saat menyetujui course.", "error");
        } finally {
          this.isApproving = false;
        }
      }
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      return date.toLocaleDateString("id-ID", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    confirmApproveCourse(courseID) {
      Swal.fire({
        title: "Konfirmasi Approval",
        text: "Apakah Anda yakin ingin menyetujui (approve) course ini?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, Approve!",
        cancelButtonText: "Batal",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.courseDataStore.approveCourse(courseID);
            await this.courseFetchStore.fetchCourseList();
          } catch (error) {
            console.error("Gagal approve course:", error);
          }
        }
      });
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
};
</script>
<template>
  <layouts-header></layouts-header>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2">Dashboard</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Dashboard
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->
  <div class="content">
    <div class="container">
      <PrincipalHeader></PrincipalHeader>
      <div class="row">
        <PrincipalSidebar></PrincipalSidebar>
        <div class="col-lg-9">
          <div class="row">
            <div class="col-md-12 text-center" v-if="sharedStore.loading">
              <BaseLoading :dialog="false"></BaseLoading>
            </div>
            <div class="col-md-12" v-else>
              <div class="row">
                <div class="col-xxl col-lg-6 col-md-6">
                  <div class="card bg-success">
                    <div class="card-body">
                      <h6 class="fw-medium mb-1 text-white">Active Courses</h6>
                      <h4 class="fw-bold text-white">
                        {{ activeCourseCount }}
                      </h4>
                    </div>
                  </div>
                </div>
                <div class="col-xxl col-lg-6 col-md-6">
                  <div class="card bg-secondary">
                    <div class="card-body">
                      <h6 class="fw-medium mb-1 text-white">
                        Disabled Courses
                      </h6>
                      <h4 class="fw-bold text-white">
                        {{ disabledCourseCount }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 d-flex justify-content-between mb-3">
                  <h5 class="fw-bold">Courses</h5>
                  <!-- <button
                      class="btn btn-outline-secondary d-flex align-items-center"
                      @click="openFilter"
                    >
                      <i class="feather-filter me-2 text-end"></i>Filters
                    </button> -->
                </div>
              </div>
              <div class="row justify-content-between">
                <div class="col-md-2">
                  <div class="mb-3">
                    <button type="button" class="btn btn-outline-secondary w-100 d-inline-flex align-items-center"
                      data-bs-toggle="modal" data-bs-target="#filterCourseModal">
                      <i class="feather-filter me-2"></i> Filter
                    </button>
                  </div>
                </div>
                <div class="col-md-4 text-end">
                  <div class="input-icon mb-3">
                    <span class="input-icon-addon">
                      <i class="isax isax-search-normal-14"></i>
                    </span>
                    <input type="email" class="form-control form-control-md" placeholder="Search"
                      v-model="courseFetchStore.searchKeyword" />
                  </div>
                </div>
              </div>
              <div class="table-responsive custom-table">
                <table class="table">
                  <thead class="thead-light">
                    <tr>
                      <th>Course</th>
                      <th>Students</th>
                      <th>In progress</th>
                      <th>Completed</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="paginatedCourses.length === 0">
                      <td colspan="6" class="text-center">No data</td>
                    </tr>
                    <tr v-for="(item, index) in paginatedCourses" :key="index">
                      <td>
                        <div class="d-flex align-items-center">
                          <router-link :to="{
                            name: 'CourseDetail',
                            params: { course_id: item.course_id },
                          }" class="avatar avatar-lg me-2 flex-shrink-0"><img class="img-fluid object-fit-cover"
                              :src="`${authStore.Url}/media/${item.thumbnail}`" alt="" /></router-link>

                          <div>
                            <h6 class="fw-medium mb-2">
                              <router-link :to="{
                                name: 'CourseDetail',
                                params: { course_id: item.course_id },
                              }">{{ item.title }}</router-link>
                            </h6>
                            <div class="d-flex align-items-center">
                              <span v-if="item.level"
                                class="d-inline-flex fs-12 align-items-center me-2 pe-2 border-end"><i
                                  class="isax isax-video-circle me-1 text-gray-9 fw-bold"></i>{{ item.level }}</span>
                              <span v-if="!item.level"
                                class="d-inline-flex fs-12 align-items-center me-2 pe-2 border-end"><i
                                  class="isax isax-video-circle me-1 text-gray-9 fw-bold"></i>-</span>
                              <span class="d-inline-flex fs-12 align-items-center"><i
                                  class="isax isax-user me-1 text-gray-9 fw-bold"></i>{{
                                    authStore.userName(item.instructor) }}</span>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>{{ item.student_enrolled_count }}</td>
                      <td>
                        {{
                          enrollmentStore.getTotalInProgressByCourse(
                            item.course_id
                          )
                        }}
                      </td>
                      <td>
                        {{
                          enrollmentStore.getTotalCompletedByCourse(
                            item.course_id
                          )
                        }}
                        <!-- <div class="d-flex align-items-center">
                        <i class="fa-solid fa-star fs-12 filled text-warning me-1"></i>
                        <span>4.5 (300)</span>
                      </div> -->
                      </td>
                      <td>
                        <span v-if="item.status === 'Active'"
                          class="badge badge-sm bg-success d-inline-flex align-items-center me-1"><i
                            class="fa-solid fa-circle fs-5 me-1"></i>{{ item.status }}</span>
                        <span v-else-if="item.status === 'New'"
                          class="badge badge-sm bg-warning d-inline-flex align-items-center me-1"><i
                            class="fa-solid fa-circle fs-5 me-1"></i>{{ item.status }}</span>
                        <span v-else-if="item.status === 'Disabled'"
                          class="badge badge-sm bg-danger d-inline-flex align-items-center me-1"><i
                            class="fa-solid fa-circle fs-5 me-1"></i>{{ item.status }}</span>
                        <span v-else class="badge badge-sm bg-info d-inline-flex align-items-center me-1"><i
                            class="fa-solid fa-circle fs-5 me-1"></i>{{ item.status }}</span>
                      </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <a v-if="isPendingApproval(item.status)" href="#"
                            class="d-inline-flex fs-14 me-1 action-icon text-success" title="Review & Approve Course"
                            data-bs-toggle="modal" data-bs-target="#approveCourseModal"
                            @click="selectCourseForApproval(item)"><i class="isax isax-tick-circle"></i></a>
                          <a href="#" class="d-inline-flex fs-14 me-1 action-icon" title="Edit Course"
                            @click="editCourse(item.course_id)"><i class="isax isax-edit-2"></i></a>
                          <a href="#" class="d-inline-flex fs-14 action-icon" title="Hapus Course"
                            :class="{ disabled: sharedStore.loading }" @click.prevent="deleteCourse(item)"><i
                              class="isax isax-trash"></i></a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row align-items-center mt-4">
                <div class="col-md-2">
                  <p class="fs-14 fw-500 text-center text-md-start">
                    Page {{ currentPage }} of {{ totalPages }}
                  </p>
                </div>
                <div class="col-md-10">
                  <ul class="pagination lms-page justify-content-center justify-content-md-end mt-2 mt-md-0">
                    <li class="page-item prev" :class="{ disabled: currentPage === 1 }">
                      <a class="page-link" href="javascript:void(0)" tabindex="-1" @click="goToPage(currentPage - 1)"><i
                          class="fas fa-angle-left"></i></a>
                    </li>
                    <li class="page-item" :class="{ active: currentPage === page }" v-for="page in totalPages"
                      :key="page">
                      <a class="page-link" href="javascript:void(0)" @click="goToPage(page)">{{ page }}</a>
                    </li>
                    <li class="page-item next" :class="{ disabled: currentPage === totalPages }">
                      <a class="page-link" href="javascript:void(0)" @click="goToPage(currentPage + 1)"><i
                          class="fas fa-angle-right"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CourseFilter />

  <!-- Modal Approve Course Basic Information -->
  <div class="modal fade" id="approveCourseModal" tabindex="-1" aria-labelledby="approveCourseModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content border-0 shadow">
        <div class="modal-header bg-light">
          <div>
            <h5 class="modal-title fw-bold" id="approveCourseModalLabel">
              <i class="isax isax-information text-primary me-2"></i>Review Basic Information Course
            </h5>
            <p class="text-muted fs-13 mb-0">
              Tinjau informasi dasar dan kurikulum materi kursus sebelum memberikan persetujuan (approve).
            </p>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            id="closeApproveModalBtn"></button>
        </div>
        <div class="modal-body p-4" v-if="selectedCourse">
          <!-- Course Header & Thumbnail -->
          <div class="card border mb-3">
            <div class="card-body">
              <div class="d-flex flex-column flex-md-row gap-3 align-items-start">
                <div
                  class="rounded overflow-hidden flex-shrink-0 border bg-light d-flex align-items-center justify-content-center"
                  style="width: 140px; height: 95px;">
                  <img v-if="selectedCourse.thumbnail" class="img-fluid object-fit-cover w-100 h-100"
                    :src="`${authStore.Url}/media/${selectedCourse.thumbnail}`" alt="Course Thumbnail" />
                  <div v-else class="text-muted text-center p-2">
                    <i class="isax isax-image fs-24 d-block mb-1"></i>
                    <span class="fs-11">No Image</span>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
                    <span class="badge bg-warning text-dark" v-if="selectedCourse.status === 'New'">
                      Status: {{ selectedCourse.status }}
                    </span>
                    <span class="badge bg-success" v-else>
                      Status: {{ selectedCourse.status }}
                    </span>
                    <span v-if="selectedCourse.course_group" class="badge bg-info-subtle text-info border border-info">
                      Group: {{ selectedCourse.course_group.name }} ({{ selectedCourse.course_group.code }})
                    </span>
                  </div>
                  <h5 class="fw-bold mb-1 text-dark">{{ selectedCourse.title }}</h5>
                  <p class="text-muted fs-13 mb-2" v-if="selectedCourse.short_description">
                    {{ selectedCourse.short_description }}
                  </p>
                  <div class="d-flex flex-wrap gap-3 fs-13 text-secondary">
                    <div>
                      <i class="isax isax-user me-1 text-primary"></i>
                      <strong>Instructor:</strong> {{ authStore.userName(selectedCourse.instructor) }}
                    </div>
                    <div>
                      <i class="isax isax-calendar me-1 text-primary"></i>
                      <strong>Dibuat:</strong> {{ formatDate(selectedCourse.created_at) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Basic Details Grid -->
          <div class="row g-3 mb-3">
            <div class="col-sm-6 col-md-3">
              <div class="p-3 border rounded bg-light text-center h-100">
                <div class="text-muted fs-12 mb-1">Level</div>
                <div class="fw-bold text-dark">{{ selectedCourse.level || '-' }}</div>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="p-3 border rounded bg-light text-center h-100">
                <div class="text-muted fs-12 mb-1">Durasi</div>
                <div class="fw-bold text-dark">{{ selectedCourse.duration ? `${selectedCourse.duration} Hari` : '-' }}
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="p-3 border rounded bg-light text-center h-100">
                <div class="text-muted fs-12 mb-1">Prerequisite Course</div>
                <div class="fw-bold text-dark">{{ selectedCourse.prerequisite_course || '-' }}</div>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="p-3 border rounded bg-light text-center h-100">
                <div class="text-muted fs-12 mb-1">Expired Date</div>
                <div class="fw-bold text-dark">{{ formatDate(selectedCourse.expired_date) }}</div>
              </div>
            </div>
          </div>

          <!-- Description Section -->
          <div class="card border mb-3" v-if="selectedCourse.description">
            <div class="card-header bg-white py-2">
              <h6 class="fw-semibold mb-0 fs-14">
                <i class="isax isax-document-text me-1 text-primary"></i>Deskripsi Course
              </h6>
            </div>
            <div class="card-body fs-14 text-secondary" v-html="selectedCourse.description"></div>
          </div>

          <!-- Course Content Section -->
          <div class="card border mb-3">
            <div class="card-header bg-white py-2 d-flex justify-content-between align-items-center">
              <h6 class="fw-semibold mb-0 fs-14">
                <i class="isax isax-book me-1 text-primary"></i>Konten & Modul Pembelajaran
              </h6>
              <span class="badge bg-secondary">
                {{ selectedCourse.content?.length || selectedCourse.content_count || 0 }} Materi
              </span>
            </div>
            <div class="card-body p-0">
              <div v-if="!selectedCourse.content || selectedCourse.content.length === 0"
                class="p-3 text-center text-muted fs-13">
                Belum ada konten materi yang diunggah.
              </div>
              <ul v-else class="list-group list-group-flush">
                <li v-for="(content, cIdx) in selectedCourse.content" :key="cIdx"
                  class="list-group-item d-flex justify-content-between align-items-center py-2">
                  <div class="d-flex align-items-center">
                    <span class="badge bg-light text-dark border me-2">#{{ content.sequence || (cIdx + 1) }}</span>
                    <div>
                      <div class="fw-medium fs-14">{{ content.title }}</div>
                      <div class="text-muted fs-12">
                        <span class="badge bg-light text-muted border me-1">{{ content.type }}</span>
                        <span v-if="content.isSkippable" class="badge bg-success-subtle text-success">Skippable</span>
                        <span v-else class="badge bg-warning-subtle text-warning">Non-skippable</span>
                      </div>
                    </div>
                  </div>
                  <div class="text-end">
                    <span class="fs-12 text-muted text-truncate d-inline-block" style="max-width: 220px;"
                      :title="content.filePath">
                      {{ content.filePath ? content.filePath.split('/').pop() : '-' }}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <!-- Exam Section -->
          <div class="card border mb-0">
            <div class="card-header bg-white py-2">
              <h6 class="fw-semibold mb-0 fs-14">
                <i class="isax isax-award me-1 text-primary"></i>Informasi Ujian Akhir (Exam)
              </h6>
            </div>
            <div class="card-body">
              <div v-if="selectedCourse.exam" class="p-3 border rounded bg-light mb-2">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <span class="fw-bold text-dark fs-14">Ujian: {{ selectedCourse.exam.course_name ||
                    selectedCourse.title }}</span>
                  <span class="badge bg-primary">{{ selectedCourse.exam.examType }}</span>
                </div>
                <div class="row g-2 fs-13 text-secondary">
                  <div class="col-md-4">
                    <strong>Batas Waktu:</strong> {{ selectedCourse.exam.time_limit_minutes }} Menit
                  </div>
                  <div class="col-md-4">
                    <strong>Bobot Pilihan Ganda:</strong> {{ selectedCourse.exam.multiple_choice_weight }}%
                  </div>
                  <div class="col-md-4">
                    <strong>Bobot Essay:</strong> {{ selectedCourse.exam.essay_weight }}%
                  </div>
                </div>
              </div>
              <div v-else class="text-muted fs-13 mb-2">
                Tidak ada ujian akhir (exam) yang dikonfigurasi.
              </div>

              <div class="fs-13 text-secondary" v-if="selectedCourse.exam">
                <i class="isax isax-document-text me-1 text-primary"></i>
                <strong>Jumlah Soal Exam:</strong> {{ selectedCourse.exam.question_count ?? selectedCourse.exam_question_count ?? 0 }} Soal
                <span v-if="selectedCourse.exam.examType !== 'Practical' && (selectedCourse.exam.question_count || selectedCourse.exam_question_count)" class="text-muted ms-1">
                  ({{ selectedCourse.exam.mc_question_count || 0 }} Pilihan Ganda, {{ selectedCourse.exam.essay_question_count || 0 }} Essay)
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer bg-light d-flex justify-content-between">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
            Batal
          </button>
          <button type="button" class="btn btn-success d-inline-flex align-items-center" :disabled="isApproving"
            @click="handleApproveCourse">
            <i class="isax isax-tick-circle me-1" v-if="!isApproving"></i>
            <span class="spinner-border spinner-border-sm me-1" v-if="isApproving" role="status"></span>
            {{ isApproving ? 'Memproses...' : 'Lanjut Approve' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
